import { render } from "./SubjectiveQuestionsPanel.vue?vue&type=template&id=2d06f116&scoped=true"
import script from "./SubjectiveQuestionsPanel.vue?vue&type=script&lang=js"
export * from "./SubjectiveQuestionsPanel.vue?vue&type=script&lang=js"

import "./SubjectiveQuestionsPanel.vue?vue&type=style&index=0&id=2d06f116&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d06f116"]])

export default __exports__